module.exports = __webpack_public_path__ + "static/email-template-welcome-098b28b7ae0707ad10c22ca6d815e109.jpg";